import { ref } from 'vue';

const supportsCSSAnchorPositioning = ref(CSS.supports('anchor-name: --test'));
document.documentElement.classList.toggle('supports-css-anchor-positioning', supportsCSSAnchorPositioning.value);

export function useCssAnchorPositioning () {
  return {
    supportsCSSAnchorPositioning,
  };
}
